var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAfNetworkElement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3170_64969)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5C1.34315 0.5 0 1.84315 0 3.5V27.5C0 29.1569 1.34315 30.5 3 30.5H27C28.6569 30.5 30 29.1569 30 27.5V3.5C30 1.84315 28.6569 0.5 27 0.5H3Z",
    fill: "#F5F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5C1.34315 0.5 0 1.84315 0 3.5V27.5C0 29.1569 1.34315 30.5 3 30.5H27C28.6569 30.5 30 29.1569 30 27.5V3.5C30 1.84315 28.6569 0.5 27 0.5H3Z",
    fill: "url(#paint0_linear_3170_64969)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5C1.34315 0.5 0 1.84315 0 3.5V27.5C0 29.1569 1.34315 30.5 3 30.5H27C28.6569 30.5 30 29.1569 30 27.5V3.5C30 1.84315 28.6569 0.5 27 0.5H3Z",
    fill: "#2C87BB",
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 7.5H8C7.45 7.5 7 7.69286 7 7.92857V13.0714C7 13.3071 7.45 13.5 8 13.5H22C22.55 13.5 23 13.3071 23 13.0714V7.92857C23 7.69286 22.55 7.5 22 7.5ZM15.5 10.5H20.5C20.78 10.5 21 10.28 21 10C21 9.72 20.78 9.5 20.5 9.5H15.5C15.22 9.5 15 9.72 15 10C15 10.28 15.22 10.5 15.5 10.5ZM9 10C9 9.72386 9.22386 9.5 9.5 9.5H10.5C10.7761 9.5 11 9.72386 11 10C11 10.2761 10.7761 10.5 10.5 10.5H9.5C9.22386 10.5 9 10.2761 9 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 13.5L14.5 21.5C14.5 22.06 14.72 22.5 15 22.5C15.28 22.5 15.5 22.06 15.5 21.5L15.5 13.5C15.5 12.94 15.28 12.5 15 12.5C14.72 12.5 14.5 12.94 14.5 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 20.5H11.5C11.225 20.5 11 20.5964 11 20.7143V23.2857C11 23.4036 11.225 23.5 11.5 23.5H18.5C18.775 23.5 19 23.4036 19 23.2857V20.7143C19 20.5964 18.775 20.5 18.5 20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 22,
    x2: 22.5,
    y2: 22,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 16.5H13.25C13.1125 16.5 13 16.6607 13 16.8571V21.1429C13 21.3393 13.1125 21.5 13.25 21.5H16.75C16.8875 21.5 17 21.3393 17 21.1429V16.8571C17 16.6607 16.8875 16.5 16.75 16.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3170_64969",
    x1: 0,
    y1: 0.5,
    x2: 0,
    y2: 30.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3170_64969"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 3,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfNetworkElement);
export default __webpack_public_path__ + "static/media/AF_Network_Element.cbf09f6efd6a9a9be901a1905f2cf540.svg";
export { ForwardRef as ReactComponent };